const getters = {
    token: state => state.admin.token,
    userInfo: state => state.admin.userInfo,
    mobile: state => state.admin.mobile,
    openId: state => state.admin.openId,
    userId: state => state.admin.userId,
    referral_code: state => state.admin.referral_code,
  }
  export default getters
  